import React, { Component } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import AreaTag from './AreaTag';
import { checkAreaType } from '../../events';
import { langCheck } from 'Pub/js/utils';
import platform from 'Pub/js/platform';
import './index.less';
const { NCCheckbox } = platform.base;
import { getMultiLangText } from '../../utilService';
 
const areaSource = {
    beginDrag(props) {
        return {
            dragType: 'lane',
            laneIndex: props.laneIndex,
            areaItem: props.area,
        };
    },
    canDrag(props) {
        return props.area && props.area.areatype === '2';
    },
};
const areaTarget = {
    drop(props, monitor) {
        const { laneIndex, area } = props;
        const dragItem = monitor.getItem();
        const { index, areaItem, dragType } = dragItem;
        if (!monitor.isOver({ shallow: true })) {return;}
        //区域类型不同不能拖拽
        if (area && area.areatype !== areaItem.areatype) {return;}
        //拖拽行
        if (dragType === 'lane') {
            if (dragItem.laneIndex === laneIndex) {return;}
            props.dragLane(dragItem.laneIndex, laneIndex);
        } else {
            //区域类型不同不能拖拽
            if (area && area.areatype !== areaItem.areatype) {return;}
            //主表不能拖到空泳道上
            if (!area && areaItem.areatype === '1') {return;}

            props.dropLogic('lane', {
                dragIndex: index,
                laneIndex: dragItem.laneIndex,
                targetLaneIndex: laneIndex,
            });
        }
    },
    canDrop(props) {
        return !props.area || props.area.areatype == '2';
    },
};

@DragSource('tag', areaSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
@DropTarget('tag', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
class AreaLane extends Component {
    constructor(props) {
        super(props);
    }

    renderTags = laneIndex => {
        return this.props.data.map((area, index) => {
            let { name } = area;
            name = getMultiLangText(area, 'name', this.props.multiOptions);
            if (area) {
                return (
                    <AreaTag
                        key={area.code}
                        name={name}
                        index={index}
                        laneIndex={laneIndex}
                        dropLogic={this.props.dropLogic}
                        areaItem={area}
                        nodrop={area.areatype == '1' && area.headcode === area.code || checkAreaType.isSide(area)}
                    />
                );
            }
        });
    };

    renderDelete = laneIndex => (
        <span
            className="lane-delete"
            onClick={() => {
                this.props.deleteLane(laneIndex);
            }}
        >
            {langCheck('ZoneSetting-000190', 'pages', this.props.json)}
        </span>
    );

    renderCheckbox = () => {
        const { area } = this.props;
        const disabled = area && area.areatype === '1';
        return (
            <NCCheckbox
                checked={this.props.checked}
                disabled={disabled}
                onChange={this.props.onChecked}
            />
        );
    };
    render() {
        const { connectDragSource, connectDropTarget, area, laneIndex, isOver } = this.props;

        return connectDragSource(
            connectDropTarget(
                <div className={`tls-list-container${isOver ? ' hover' : ''}`}>
                    <div className="tls-list">
                        {this.renderCheckbox()}
                        <span className="lane-index">{laneIndex + 1}</span>
                        <div className="tags">{this.renderTags(laneIndex)}</div>
                        {!area && this.renderDelete(laneIndex)}
                        {area && area.areatype !== '1' && <i className="iconfont icon-tuodong"></i>}
                    </div>
                </div>,
            ),
        );
    }
}

export default AreaLane;
